export default {
    "entityName": "siterequest",
    upsert: 'full',
    // "title": "Site request",
    "pagination": {
        "itemsPerPage": 5,
        "page": 1,
        "sortBy": "n_patients",
        "descending": true
    },
    "fields": [
        {
            "value": "protocol_id",
            "text": "Protocol",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                filter: true
            },
            small: true,
            filter: () => ({ status: 'ACTIVE' }),
            "title": "name",
            validators: ['required']
        },
        {
            "value": "site_id",
            "reference": "protocol_has_site",
            "text": "Site",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                filter: true
            },
            id: "site_id",
            title: 'site.name',
            subtitle: item => `${item.site.city} - ${item.site.code}`,
            // readonly: (item, state) => !item.protocol_id || state.user.role === 'Site',
            filter: (item, search) => {
                if (!search) {
                    return  { protocol_id: item.protocol_id }
                }
                return { protocol_id: item.protocol_id, 'site.name': [{ 'site.name': `%${search}%`},
                    {'site.city': `%${search}%`}, {'site.code': `%${search}%`}]}
            },
            deps: ['protocol_id'],
            default: (item, field, selected, state) => {
                return state.user.site_id || undefined
            },
            visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User',
            validators: ['required']
        },
        // {
        //     "value": "pharmacy_id",
        //     "text": "Pharmacy",
        //     "type": "autocomplete",
        //     "title": "name",
        //     "subtitle": "name",
        //     readonly: item => !item.site_id || !item.protocol_id,
        //     deps: ['site_id'],
        //     filter: (item) => ({ site_id: item.site_id }),
        //     validators: ['required']
        // },        
        // {
        //     "value": "reference_pharmacy_id",
        //     "text": "Reference",
        //     "type": "autocomplete",
        //     "title": item => `${item.name} ${item.surname}`,
        //     "subtitle": 'email',
        //     deps: ['pharmacy_id'],
        //     readonly: item => !item.pharmacy_id,
        //     filter: (item) => ({ pharmacy_id: item.pharmacy_id }),
        //     validators: ['required']
        // },
        {
            "value": "status",
            "text": "Status",
            "type": "list",
            "table": {
                "sortable": true,
                "filter": true
            },
            "list": [
                "NEW", "CONFIRMED", "REPLIED"
            ],
            visible: false
        },
        {
            mini: true,
            "value": "n_patients",
            "text": "N patients",
            "type": "number",
            "table": {
                "sortable": true,
                "filter": false
            },
            "validators": [
                (field, value) => {
                    return !!value || value === 0 || 'N patients is required'
                },       
                "number"
            ]
        },
        {
            mini: true,
            "value": "is_transfer",
            "text": "Site transfer",
            "type": "check",
            visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User'
        },
        {
            mini: true,
            "value": "site_source_id",
            "text": "Transfer from site",
            "type": "autocomplete",
            reference: 'protocol_has_site',
            deps: ['is_transfer'],
            visible: (item, state) => item.is_transfer && (state.user.role === 'Administrator' || state.user.role === 'EMN User'),
            id: "site_id",
            title: 'site.name',
            subtitle: item => `${item.site.city} - ${item.site.code}`,
            // readonly: (item, state) => !item.protocol_id || state.user.role === 'Site',
            filter: (item, search) => {
                if (!search) {
                    return  { protocol_id: item.protocol_id }
                }
                return { protocol_id: item.protocol_id, 'site.name': [{ 'site.name': `%${search}%`},
                    {'site.city': `%${search}%`}, {'site.code': `%${search}%`}]}
            },
            validators: ['required']
        },
        {
            mini: true,
            "value": "urgent",
            "text": "Urgent",
            "type": "check",
            "table": {
                "sortable": true,
                "filter": true
            }
        },
        {
            mini: true,
            "value": "request_arrival_date",
            "text": "Request arrival date",
            "type": "datetime",
            deps: ['urgent'],
            visible: item => item.urgent,
            min: true,
            validators: [
                (field, value, item) => {
                    return item.urgent && !!value || 'Request arrival date is required'
                }
            ]
        },
        {
            full: true,
            "value": "urgency_reason",
            "text": "Urgency reason",
            "type": "textarea",
            deps: ['urgent'],
            visible: item => item.urgent,
            validators: [
                (field, value, item) => {
                    return item.urgent && !!value || 'Urgency reason is required'
                }
            ]            
        },

    ],
    "actions": [
        "upsert"
    ]
}
